/** @format */

import { message, Modal, Spin } from "antd";
import { useEffect, useState } from "react";
import { getReferralCode } from "../../../redux/pricing-plan/action";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../shared/Loader";
import { MdOutlineContentCopy } from "react-icons/md";
import { FaFacebookF, FaTwitter, FaTelegram, FaWhatsapp } from "react-icons/fa";
import styles from "../../../styles/Components/pricing-plan/mini-pricing/InviteFriendsModal.module.css";
import { BsPersonFillAdd } from "react-icons/bs";

function InviteFriendsModal({ show, setShow, link }) {
  const {
    main: { userData },
    pricingPlan: { referralCode, referralCodeLoading },
  } = useSelector((state) => state);

  const [showCopyIndicator, setShowCopyIndicator] = useState(false);
  const dispatch = useDispatch();

  const invitationLink = `https://t.me/cryptocrispy_bot?start=${referralCode}`;

  const copyHandler = async (text, type = "link") => {
    try {
      await navigator.clipboard.writeText(text);
      setShowCopyIndicator(true);
      setTimeout(() => setShowCopyIndicator(false), 2000);
      // message.success(`Copied ${type} to clipboard`);
    } catch (err) {
      message.error("Failed to copy to clipboard");
    }
  };

  const shareHandlers = {
    facebook: () => {
      window.open(
        `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
          link || invitationLink,
        )}`,
        "_blank",
      );
    },
    twitter: () => {
      window.open(
        `https://twitter.com/intent/tweet?url=${encodeURIComponent(
          link || invitationLink,
        )}`,
        "_blank",
      );
    },
    telegram: () => {
      window.open(
        `https://t.me/share/url?url=${encodeURIComponent(
          link || invitationLink,
        )}`,
        "_blank",
      );
    },
    whatsapp: () => {
      window.open(
        `https://wa.me/?text=${encodeURIComponent(link || invitationLink)}`,
        "_blank",
      );
    },
  };

  useEffect(() => {
    if (!referralCode && !link) {
      if (userData?.email) {
        dispatch(
          getReferralCode(
            userData?.email,
            userData?.["custom:custom_username"],
          ),
        );
      }
    }
  }, [dispatch, link, referralCode, userData]);

  return (
    <Modal
      open={show}
      onCancel={(e) => {
        e.stopPropagation();
        setShow(false);
      }}
      centered
      footer={null}
      width={400}
      className={styles.modal}
    >
      {referralCodeLoading ? (
        <Loader title="Please wait" height={130} />
      ) : (
        referralCode && (
          <div className={styles.modalContent}>
            <h2 className={styles.title}>
              <BsPersonFillAdd
                color="#0c4cfc"
                style={{ marginRight: "17px" }}
              />
              Share your invitation link with your friends:
            </h2>

            <div
              className={styles.linkContainer}
              onClick={() => copyHandler(link || invitationLink)}
            >
              <p className={styles.link}>{link || invitationLink}</p>
              <span className={styles.copyIcon}>
                <MdOutlineContentCopy size={18} />
              </span>
            </div>

            <div className={styles.shareSection}>
              <p className={styles.shareTitle}>Share via:</p>
              <div className={styles.shareButtons}>
                <button
                  className={`${styles.shareButton} ${styles.facebook}`}
                  onClick={shareHandlers.facebook}
                >
                  <FaFacebookF size={18} />
                </button>
                <button
                  className={`${styles.shareButton} ${styles.twitter}`}
                  onClick={shareHandlers.twitter}
                >
                  <FaTwitter size={18} />
                </button>
                <button
                  className={`${styles.shareButton} ${styles.telegram}`}
                  onClick={shareHandlers.telegram}
                >
                  <FaTelegram size={18} />
                </button>
                <button
                  className={`${styles.shareButton} ${styles.whatsapp}`}
                  onClick={shareHandlers.whatsapp}
                >
                  <FaWhatsapp size={18} />
                </button>
              </div>
            </div>

            <div
              className={styles.referralCode}
              onClick={() => copyHandler(referralCode, "referral code")}
            >
              <p className={styles.referralLabel}>Referral Code:</p>
              <p className={styles.referralValue}>{referralCode}</p>
              <MdOutlineContentCopy size={16} />
            </div>
          </div>
        )
      )}
      {showCopyIndicator && (
        <div className={styles.copyIndicator}>Copied to clipboard!</div>
      )}
    </Modal>
  );
}

export default InviteFriendsModal;
